export enum LogActions {
  reserve = "reserve",
}
